"use client"

import { Banana } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BananaIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BananaIcon = component(Icon)({ as: Banana })
